import { createApp } from "vue";
import VueClickAway from "vue3-click-away";

import KnowledgeHub from "~/vue/KnowledgeHub.vue";

// Main app
const knowledgeHub = async () => {
	const app = createApp(KnowledgeHub);

	app.use(VueClickAway);
	app.use(window.pinia);

	return app.mount("#knowledge-hub");
};

// Execute async function
knowledgeHub().then(() => {
	console.log();
});
